import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { fetchSources } from "@/lib/api";

export default function SourcesPage() {
  const [sources, setSources] = useState([]);
  useEffect(() => { document.title = "Fontes | Notícia 365"; fetchSources().then(setSources); }, []);
  const online = sources.filter((s) => s.ok);
  return (
    <div className="mx-auto max-w-7xl px-4 pt-8 sm:px-6 lg:px-8">
      <h1 className="font-serif-display text-4xl font-black sm:text-5xl">Fontes</h1>
      <p className="mt-2 text-muted-foreground"><b className="text-foreground">{online.length}</b> de {sources.length} portais moçambicanos a enviar notícias agora.</p>
      <div className="mt-10 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {sources.map((s) => (
          <Link key={s.slug} to={s.ok ? `/fonte/${s.slug}` : "#"} state={{ name: s.name }} data-testid={`source-card-${s.slug}`}
            className={`group flex items-center gap-4 rounded-2xl border bg-card p-5 transition-colors ${s.ok ? "hover:border-primary" : "pointer-events-none opacity-50"}`}>
            <span className="grid h-12 w-12 place-items-center rounded-xl bg-muted font-serif-display text-xl font-black text-primary">{s.name[0]}</span>
            <div className="flex-1">
              <p className="font-bold">{s.name}</p>
              <p className="font-mono-meta text-[11px] uppercase tracking-wider text-muted-foreground">
                <span className={`mr-1.5 inline-block h-2 w-2 rounded-full ${s.ok ? "bg-emerald-500" : "bg-muted-foreground"}`} />
                {s.ok ? `${s.count} notícias recentes` : "Indisponível"}
              </p>
            </div>
            <ArrowUpRight size={18} className="text-muted-foreground transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-primary" />
          </Link>
        ))}
      </div>
    </div>
  );
}
